<script setup>
import { ajax } from 'main.core';
import { onMounted } from 'ui.vue3';
import { storeToRefs } from 'ui.vue3.pinia';
import ArendaFormDialog from './Dialogs/ArendaFormDialog.vue';
import CalculatorHeader from './CalculatorHeader.vue';
import CalculatorParams from './CalculatorParams.vue';
import CalculatorSidebar from './CalculatorSidebar.vue';
import EnterpriseFormDialog from './Dialogs/EnterpriseFormDialog.vue';
import FreshFormDialog from './Dialogs/FreshFormDialog.vue';
import HowTo from './HowTo/HowTo.vue';
import useCalculatorStore from '../store/calculator.js';
import useUserStore from '../store/user.js';

const props = defineProps({
  priceDate: {
    type: String,
    default: '',
  },

  priceDetailsUrl: {
    type: String,
    default: '',
  },

  subscriptionUrl: {
    type: String,
    default: '',
  },

  arendaOfferUrl: {
    type: String,
    default: '',
  },
});

const calculator = useCalculatorStore();
const {
  dialogArendaForm,
  dialogEnterpriseForm,
  dialogFreshForm,
  groups,
  periods,
  priceDate,
  priceDetailsUrl,
  programs,
  selectedPeriod,
  selectedProgram,
  selectedTariff,
  services,
  subscriptionUrl,
  tariffs,
  whereDoYouKnow,
  arendaOfferUrl,
} = storeToRefs(calculator);

const user = useUserStore();
const { companyId, companyName, fullName, email, phone } = storeToRefs(user);

onMounted(async () => {
  const response = await ajax.runComponentAction('stsl:cloud.calculator', 'data', {mode: 'ajax', method: 'GET'});
  groups.value = response.data.groups;
  periods.value = response.data.periods;
  tariffs.value = response.data.tariffs;
  programs.value = response.data.programs;
  whereDoYouKnow.value = response.data.sources;
  const defaultPeriod = response.data.periods.find(p => p.default);
  if (defaultPeriod) {
    selectedPeriod.value = defaultPeriod.id;
  }
  const defaultProgram = response.data.programs.find(p => p.default);
  if (defaultProgram) {
    selectedProgram.value = defaultProgram.id;
  }
  const defaultTariff = response.data.tariffs.find(t => t.default);
  if (defaultTariff) {
    selectedTariff.value = defaultTariff.id;
  }
  if (props.priceDate) {
    priceDate.value = props.priceDate;
  }
  if (props.priceDetailsUrl) {
    priceDetailsUrl.value = props.priceDetailsUrl;
  }
  if (props.subscriptionUrl) {
    subscriptionUrl.value = props.subscriptionUrl;
  }
  if (props.arendaOfferUrl) {
    arendaOfferUrl.value = props.arendaOfferUrl;
  }
  if (response.data.user.full_name) {
    fullName.value = response.data.user.full_name;
  }
  if (response.data.user.email) {
    email.value = response.data.user.email;
  }
  if (response.data.user.phone) {
    phone.value = response.data.user.phone;
  }
  if (response.data.user.companyId) {
    companyId.value = response.data.user.companyId;
  }
  if (response.data.user.companyName) {
    companyName.value = response.data.user.companyName;
  }
  services.value = response.data.services;
});
</script>

<template>
  <div class="cloud-calculator">
    <CalculatorHeader/>
    <HowTo/>
    <CalculatorParams/>
    <CalculatorSidebar/>
    <FreshFormDialog v-if="dialogFreshForm" @close="dialogFreshForm = false"/>
    <ArendaFormDialog v-if="dialogArendaForm" @close="dialogArendaForm = false"/>
    <EnterpriseFormDialog v-if="dialogEnterpriseForm" @close="dialogEnterpriseForm = false"/>
  </div>
</template>
